export default {
    emits: ["update:modelValue"],

    props: {
        modelValue: [String, Number, Object],
        placeholder: String,
        error: String,
        type: String,
        readonly: Boolean,
    },

    data() {
        return {
            inputWidth: null,
            placeholderWidth: null,
            containerWidth: null,
            hasFocus: false,
            inputClasses: [
                "block",
                "w-full",
                "p-3",
                "border-2",
                "border-solid",
                "rounded",
                "text-dark",
                "border-dark",
                "focus:ring-0",
                {"focus:border-primary": !this.readonly},
                "focus-visible:outline-none",
                {"border-[#979797]": this.readonly}
            ],
        };
    },

    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                if (!this.readonly) {
                    this.$emit("update:modelValue", value);
                }
            },
        },
        placeholderFloating() {
            return this.hasFocus || this.modelValue;
        },
        inputPlaceholderSpace() {
            if (this.containerWidth === null || this.placeholderWidth === null)
                return null;

            return this.containerWidth - this.placeholderWidth;
        },
        centrePlaceholder() {
            if (this.inputPlaceholderSpace === null) return false;

            // If space left in the input after placeholder is floating
            // is less than 50px, just centre it instead
            return this.inputPlaceholderSpace <= 50;
        },
        labelClasses() {
            return [
                "absolute",
                "transition-all",
                "text-dark",
                this.placeholderFloating
                    ? [
                          "-top-2",
                          "text-sm",
                          "bg-white",
                          "px-1",
                          this.centrePlaceholder
                              ? ["left-1/2", "-translate-x-1/2"]
                              : ["left-5"],
                      ]
                    : ["bg-transparent", "top-3", "left-3"],
            ];
        },
    },

    methods: {
        focus() {
            if (this.$refs.input) {
                this.$refs.input.focus();
            }

            this.hasFocus = true;
        },
        blur() {
            if (this.$refs.input) {
                this.$refs.input.blur();
            }

            this.hasFocus = false;
        },
        handleResize() {
            this.getRefWidth("input", "inputWidth");
            this.getRefWidth("placeholder", "placeholderWidth");
            this.getRefWidth("container", "containerWidth");
        },
        getRefWidth(ref, dataVariable) {
            if (this.$refs[ref]) {
                this[dataVariable] = this.$refs[ref].offsetWidth;
            }
        },
    },

    // bind event handlers to the `handleResize` method
    mounted: function () {
        this.handleResize();

        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    },
};
